const validate = values => {
    const errors = {}
    if (values.representative) {
        const representativesArrayErrors = []
        values.representative.forEach((representative, representativeIndex) => {
            const representativeErrors = {}
            if (!representative || !representative.name) {
                representativeErrors.name = 'Este Campo es Obligatorio'
                representativesArrayErrors[representativeIndex] = representativeErrors
            }
            if (!representative || !representative.cuil) {
                representativeErrors.cuil = 'Este Campo es Obligatorio'
                representativesArrayErrors[representativeIndex] = representativeErrors
            }
			if (representative && representative.cuil &&
                (!/(\d{11})$/.test(representative.cuil) || !/(2\d{10})$/.test(representative.cuil))) {
                representativeErrors.cuil = 'El CUIL no es válido'
                representativesArrayErrors[representativeIndex] = representativeErrors
            }
        })
        if (representativesArrayErrors.length) {
            errors.representative = representativesArrayErrors
        }
    }
    return errors
}
 export default validate



/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsCooperativeRepresentativesForm.js
 **/